import React, { useState } from "react";
import "./style.scss";
import ILogo from '../../images/logo.png'
import { HOME_PAGE } from '../../constants'
import { useConnectWallet } from '../../hooks/useConnectWallet'
import  ModalAccountWallet from '../ModalAccountWallet '
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamation  ,  faBars ,faTimes } from '@fortawesome/free-solid-svg-icons'
import { shortenAddress, isCorrectNetwork } from '../../utils/'
import {Link} from "react-router-dom";
import { useWalletModalToggle }  from '../../hooks/useApplication'

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const {
    connectWallet,
    account,
    chainId,
  } = useConnectWallet()
  const [isShowModal, setShowModal] = useState<boolean>(false)
  const onCloseModal = () => {
    setShowModal(false)
  }
  const   toggleWalletModal =   useWalletModalToggle()

  return (
    <div className='header-nav'>
      <div className='logo-nav'>
        <div className='mobile-menu' onClick={handleClick}>
          {click ? (
            <button className='btn close-menu-btn'>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          ) : (
            <button className='btn burger-btn'>
              <FontAwesomeIcon icon={faBars} />
            </button>
          )}
        </div>

        <div className='logo-container'>
          <a className='text-home' href={HOME_PAGE}>
            <div className='wrap-logo'>
              <img alt='' src={ILogo} />
            </div>
          </a>
        </div>
      </div>

      <div className='wrap-menu'>
        <ul className={click ? 'nav-options active' : 'nav-options'}>
          <li className='option' onClick={closeMobileMenu}>
            <a href={`${HOME_PAGE}`}>Our Journey</a>
          </li>
          <li className='option' onClick={closeMobileMenu}>
            <Link to='/swap'>Swap</Link>
          </li>
          <li className='option' onClick={closeMobileMenu}>
            <Link to='/affiliateProgarm'>Affiliate</Link>
          </li>
          <li className='option' onClick={closeMobileMenu}>
            <Link to='/bonus'>Bonus</Link>
          </li>
          <li className='option' onClick={closeMobileMenu}>
            <a href={`${HOME_PAGE}howto`}>How to</a>
          </li>
        </ul>
      </div>

      <div className='wrap-account-btn'>
        {!isCorrectNetwork(chainId) && account ? (
          <div className='warpper-network-status'>
            <label>
              <FontAwesomeIcon icon={faExclamation} />
              Wrong network
            </label>
          </div>
        ) : (
          <React.Fragment>
            {account ? (
              <button
                onClick={setShowModal}
                className='btn  account-btn'
                type='button'
              >
                {account ? shortenAddress(account) : 'Connect'}
              </button>
            ) : (
              <button
                onClick={toggleWalletModal}
                className='btn  connect-btn'
                type='button'
              >
                Connect Wallet
              </button>
            )}
          </React.Fragment>
        )}
      </div>

      <ModalAccountWallet
        account={account}
        isShowModal={isShowModal}
        onCloseModal={onCloseModal}
      />

      {/* <ModalWallet/> */}
    </div>
  )
};

export default Header;
